import { BrandLogo, VStack } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import Link from 'components/link';
import RewardsLogo from 'pages/loyalty/loyalty-rewards-logo';
import { isWeb } from 'utils/environment';

export const GetStartedText = withTypography({
  variant: 'copyTwo',
  textAlign: 'center',
  // Web bumps this up one step (from copyTwo 12dp to lg 18dp); native keeps the variant default.
  fontSize: isWeb ? 'lg' : undefined,
});

export const LogoLink = Link.withConfig({
  justifyContent: 'center',
});

export const SignUpHeadlineContainer = VStack.withConfig({
  paddingTop: {
    sm: '6',
  },
});

export const StyledBKLogo = BrandLogo.withConfig({
  width: '24',
  height: '24',
  marginBottom: '1',
});

export const StyledRewardsLogo = RewardsLogo.withConfig({
  height: {
    base: '12',
    sm: '16',
  },
  minWidth: '200px',
  _web: {
    height: '64px',
    width: '260px',
    cursor: 'pointer',
  },
});

export const RewardsLinkStyled = Link.withConfig({
  isInline: true,
  isUnderlined: true,
  _text: {
    variant: 'copyTwo',
    textDecoration: 'underline',
    fontSize: 'xs',
    paddingTop: '3px',
  },
});
